import type { NotificationCheckpoint } from './notificationCheckpointCatalog';

export type TemplateLanguage = 'th' | 'en';
export type NotificationTemplate = { title: string; body: string; sms?: string; email_subject?: string };
export type NotificationEventTemplates = Record<string, Partial<Record<TemplateLanguage, NotificationTemplate>>>;
export type CheckpointTemplate = NotificationTemplate & { event: string };

// Direct-request messages live outside the event notification dispatcher.
// Sources: passwordless_auth_service.py, app_support_service.py, wallet.py, system.py.
const directTemplates: Record<string, NotificationTemplate> = {
  'login-otp': { title: 'Beaw verification code', body: 'Beaw: {code}\nรหัสใช้ได้ 5 นาที สำหรับคุณเท่านั้น', sms: 'Beaw: {code}\nรหัสใช้ได้ 5 นาที สำหรับคุณเท่านั้น' },
  'creator-phone-otp': { title: '', body: '', sms: 'beaw.club OTP: {otp}' },
  'wallet-topup-otp': { title: '', body: '', sms: 'beaw.club wallet top-up code: {otp}. Amount {amount_label}. Expires in {otp_ttl_minutes} min.' },
  'sms-test': { title: '', body: '', sms: '{message} (ข้อความที่ Admin กรอก)\nหากเว้นว่าง: beaw.club OTP: {otp}' },
  'manual-notification': { title: '{title}', body: '{body}', sms: '{title}\n{body}' },
};

export function checkpointTemplates(item: NotificationCheckpoint, events: NotificationEventTemplates, language: TemplateLanguage): CheckpointTemplate[] {
  const direct = directTemplates[item.id];
  if (direct) return [{ ...direct, event: item.id }];
  const milestone = /^review-milestone-(3|10|50)$/.exec(item.id);
  const context: Record<string, string> = milestone ? {
    threshold: milestone[1],
    level: ({ '3': '1', '10': '2', '50': '3' } as Record<string, string>)[milestone[1]],
    name_en: ({ '3': 'Reviewer', '10': 'Creator', '50': 'Creator+' } as Record<string, string>)[milestone[1]],
  } : {};
  const format = (value: string) => value.replace(/\{([^{}]+)\}/g, (token, key: string) => context[key] ?? token);
  return (item.events || []).flatMap(event => {
    const template = events[event]?.[language] ?? events[event]?.th;
    return template ? [{
      event, title: format(template.title), body: format(template.body),
      sms: format(template.sms ?? `${template.title}\n${template.body}`),
      email_subject: format(template.email_subject ?? template.title),
    }] : [];
  });
}
